import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { BUS_BODY_WORK_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes, matchPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import InternalResource from '../../../common/resource/InternalResource';
import BusBodyworkBasicInformationResource from "./resources/BusBodyworkBasicInformationResource";
import BusBodyworkToolbar from "./BusBodyworkToolbar";
import { clearBusBodyWork, getBusBodyWork } from "../../../../actions/bus/BusBodyWork";

export const BusBodywork = ({
    breadcrumbs,
  dispatchGetBusBodywork,
  dispatchClearBusBodywork,
  match: {
    params: { id: busBodyWorkId },
  },
  loading,
  busBodywork,
}) => {
  useLayoutEffect(() => {
    dispatchGetBusBodywork({ busBodyWorkId });

    return () => dispatchClearBusBodywork();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (busBodywork.isEmpty())
    content = <NoDataResource returnPage={BUS_BODY_WORK_PATH} />;
  else {
    const busBodyworkJson = busBodywork.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <BusBodyworkBasicInformationResource {...busBodyworkJson} />
        <InternalResource id={busBodyworkJson.id}
          createDate={busBodyworkJson.createDate}
          lastUpdate={busBodyworkJson.lastUpdate}/>
      </>
    );

    toolbar = <BusBodyworkToolbar busBodyWorkId={busBodyworkJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Carrocería"
      content={content}
    />
  );
};

BusBodywork.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBusBodywork: PropTypes.func.isRequired,
  dispatchGetBusBodywork: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  busBodywork: PropTypes.instanceOf(Immutable.Map).isRequired,
};

BusBodywork.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBusBodywork: clearBusBodyWork,
  dispatchGetBusBodywork: getBusBodyWork
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carrocerías',
      href: BUS_BODY_WORK_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  busBodywork: BusUnit.BusBodyWork.getIn(['current', 'content']),
  loading: !BusUnit.BusBodyWork.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusBodywork);